@if(headerExists()) {
  <seth-header [headerContent]="headerContent" [isMobile]="isMobile$()"></seth-header>
} @else {
  <div class="header-skeletons">
    <ngx-skeleton-loader count="1" appearance="line" animation="pulse" [theme]="{ height: '4rem', width: '60%'}"></ngx-skeleton-loader>
    <ngx-skeleton-loader count="1" appearance="line" animation="pulse" [theme]="{ height: '4rem', width: '10%'}"></ngx-skeleton-loader>
    <ngx-skeleton-loader count="1" appearance="line" animation="pulse" [theme]="{ height: '4rem', width: '10%'}"></ngx-skeleton-loader>
    <ngx-skeleton-loader count="1" appearance="line" animation="pulse" [theme]="{ height: '4rem', width: '10%'}"></ngx-skeleton-loader>
    <ngx-skeleton-loader count="1" appearance="line" animation="pulse" [theme]="{ height: '4rem', width: '10%'}"></ngx-skeleton-loader>
  </div>
}
<main class="main-container">
  <div class="col-container">
    @if (isMobile$() || isTabletSize$()) {
      <seth-progress-flow></seth-progress-flow>
    }
    @else {
      <seth-progress-tracker></seth-progress-tracker>
    }
    <div class="dynamic-page-content">
      <seth-patient-summary></seth-patient-summary>
        @if(isLoading$()) {
          <div class="spinner-wrapper">
            <mat-spinner data-testid="spinner"></mat-spinner>
          </div>
        }
        @else {
          <router-outlet />
        }
    </div>
  </div>
</main>
@if(footerExists()) {
  <seth-footer [footerContent]="footerContent"></seth-footer>
} @else {
  <ngx-skeleton-loader count="1" appearance="line" animation="pulse" [theme]="{ height: '20rem', width: '20%'}"></ngx-skeleton-loader>
  <ngx-skeleton-loader count="1" appearance="line" animation="pulse" [theme]="{ height: '20rem', width: '60%'}"></ngx-skeleton-loader>
  <ngx-skeleton-loader count="1" appearance="line" animation="pulse" [theme]="{ height: '20rem', width: '20%'}"></ngx-skeleton-loader>
}
